export const CountryCode = Object.freeze({
  US: 'US',
  AN: 'AN',
  BR: 'BR',
  IN: 'IN',
  FR: 'FR',
  HK: 'HK',
  TW: 'TW',
  HU: 'HU',
  PT: 'PT',
  CO: 'CO',
});

export const CallingCode = Object.freeze({
  US: '1',
});

export const CallingCodeBeforePhoneNumberRegExp = '^([0-9]+)-(.*)$';

// This should be in sync with excluded countries in AdsAppUI/private/UI/Common/Microsoft.ClientCenter.Repository/Dictionaries/CountryMapping.cs GetVatApplicableCountriesMapping
export const NonEMEAVatCountries = ['NZ', 'RS', 'SG'];

export const YahooMarkets = [CountryCode.HK, CountryCode.TW];
